import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useAuth } from "../../../../context/AuthContext";
import PropTypes from "prop-types";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useLoading } from "../../../../context/LoadingContext";
import { FloatingControlComponent, FormCheckComponent } from "../../../../components/FormComponent";
import PaginationComponent from "../../../../components/PaginationComponent";
import {
  formatDate,
  formatSplitKey,
  formatTime
} from "../../../../commons/FormatValue";
import Table from "../../../../components/Table";

import CardDisplayComponent from "../../../../components/CardDisplayComponent";
import TechnicianReceiveService from "../../../../services/technicianreceive.service";
import {
  filteredItemInArray, findItemInArray,
} from "../../../../utils/ManageArray";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import { useAlert } from "../../../../context/AlertContext";
import PrintButton from "../../../../components/PrintButton";
import ReportHeadComponent from "../../../../components/ReportHeadComponent";
import { formatDateTime } from "../../../../commons/FormatValue";
import CustContractItemsService from "../../../../services/custcontractitem.service";
import BillOfReqHdService from "../../../../services/billofreqhd.service";

const PreviewEquipForm = () => {
  const navigate = useNavigate();
  const canvasRef = useRef(null);
  const { user } = useAuth();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [currentPage, setCurrentPage] = useState(1);
  const [CustContractItems, setCustContractItems] = useState([]);
  const Seq = {
    ...state[0],
    Printed_By: user?.username,
    Printed_Date_Time: formatDateTime(new Date().toISOString()),
    Approver: ""
  };
  const inputField = {
    headerReport: [
      {
        name: "Bill_Doc_No",
        label: "เลขที่ใบขอเบิก",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 12
      },
    ],
    Inform: [
      {
        name: "Request_Name",
        label: "ชื่อผู้ขอ",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "แผนก",
        label: "แผนก",
        classNames: { col: "mb-3", label: "mb-1" },
        // size: 6
      },
      {
        name: "Seq_No",
        label: "เลขที่ใบสั่งงาน",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "Ref_Do_No",
        label: "อ้างอิง DO",
        classNames: { col: "mb-3", label: "mb-1" },
        // size: "1_5"
      },
      {
        name: "Cus_Code",
        label: "รหัสลูกค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "2"
      },
      {
        name: "Cus_Name",
        label: "ชื่อลูกค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 4
      },
      {
        name: "Project_No",
        label: "หมายเลขโครงการ",
        classNames: { col: "mb-3", label: "mb-1" },
        format: (row) => formatDate(row)
      },
      {
        name: "Req_Date",
        label: "วันที่ขอเบิก",
        classNames: { col: "mb-3", label: "mb-1" },
        format: (row) => formatTime(row)
      },
      {
        name: "Branch_No",
        label: "เลขที่สาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 2,
      },
      {
        name: "Branch_Name",
        label: "ชื่อสาขา",
        size: "7",
        classNames: { col: "mb-3", label: "mb-1" },
        format: (row) => formatDate(row)
      },
      {
        name: "Time",
        label: "เวลา",
        classNames: { col: "mb-3", label: "mb-1" },
        format: (row) => formatTime(row)
      },
      {
        name: "JobType.Job_Type_Name",
        label: "ประเภทงาน",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "Job_Type_SubName",
        label: "ประเภทงานย่อย",
        classNames: { col: "mb-3", label: "mb-1" },
      },
      {
        name: "Pm_Num",
        label: "PM/ครั้งที่",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "Warehouse",
        label: "คลัง",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "Remark",
        label: "หมายเหตุ",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 12,
      },
    ],
    Other: [
      { name: "Printed_By", label: "ผู้ขอเบิก" },
      { name: "Approver", label: "ผู้อนุมัติเบิก" }
    ]
  };

  const showData = (field) => {
    return field.map(
      (
        { name, label, size, classNames, style, findValue },
        idx
      ) => {
        let joinData = formatSplitKey(name, ".", Seq);
        var parts = name.split(".");
        const result = currentData ? (parts.length == 1 ? currentData[name]
          : currentData[parts[0]][parts[1]]) : ""
        return (
          <Col
            key={idx}
            sm={size ? size : size === null ? null : 3}
            className={classNames?.col}
          >
            {name && (
              <FloatingControlComponent
                readOnly
                type="text"
                name={name}
                label={label}
                className={classNames}
                style={style}
                value={result}
              />
            )}
          </Col>
        );
      }
    );
  };

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: BillOfReqHdService.getEquipmentRequisition({ bill_doc_no: state.RequestNumber }),
      callback: (res) => {
        const data = res.data[0]
        setCurrentData({
          ...data,
          Seq_No: data.SeqOthersJob?.Seq_Oth_No ||
            data.SeqPmJob?.Seq_Pm_No ||
            data.SeqRepairJob?.Seq_Serv_No ||
            data.SeqInstallJob?.Seq_Inst_No,
          Cus_Code: data.SeqOthersJob.InformOtherJob?.Customer.Cus_Code,
          Cus_Name: data.SeqOthersJob.InformOtherJob?.Customer.Cus_Name,
          //Req_Date:
          //Branch_No
          //Branch_Name
          //Time
          // Job_Type_Name: items.BillOfReqHd.Job_Type_Name || items.BillOfReqHd.Job_Type_Id,
          // Job_Type_SubName: items.BillOfReqHd.Job_Type_Sub_Name,
          // Pm_Num: items.TechnicianPlans.SeqOthersJob.InformOtherJob.PM_List,
          // Warehouse: items.Wh_Code,
          Printed_By: user?.username,
          Printed_Date_Time: currentDate
        })
      }
    });
  }, []);

  const currentDate = formatDateTime(new Date().toISOString());
  // const currentData = Repair?.[currentPage - 1];
  const [currentData, setCurrentData] = useState()
  // console.log('currentData', currentData?.Item)
  const columns = {
    Item: [
      {
        name: "ลำดับ",
        selector: (row) => row?.rowIndex, width: "82px"
      },
      {
        name: "รหัสสินค้า/อุปกรณ์/อะไหล่",
        selector: (row) => row?.Item?.Item_Code,
        grow: 3
      },
      {
        name: "รายละเอียดสินค้า/อุปกรณ์/อะไหล่",
        selector: (row) => row?.Item?.Item_Name_TH || row?.Item?.Item_Name_EN,
        grow: 5
      },
      {
        name: "จำนวน",
        selector: (row) => row?.Iss_Qty
      },
      {
        name: "หน่วย",
        selector: (row) => row?.Item?.Unit
      },
    ],
    Standard: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex, width: "82px" },
      { name: "ขั้นตอนการปฏิบัติงาน", selector: (row) => row },
      { name: "Priority", selector: (row) => row },
      { name: "เหตุผลที่ข้ามขั้นตอน", selector: (row) => row },
      { name: "วันที่ปฏิบัติงาน", selector: (row) => row },
      { name: "ถ่ายรูป", selector: (row) => row },
      { name: "รูปภาพ", selector: (row) => row },
      { name: "หมายเหตุ", selector: (row) => row }
    ],
    Sperepart: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex, width: "82px" },
      { name: "รหัสอุปกรณ์/อะไหล่", selector: (row) => row },
      { name: "Model Number", selector: (row) => row },
      { name: "Barcode", selector: (row) => row },
      { name: "สถานะชุดกรอง", selector: (row) => row },
      { name: "วันที่เปลี่ยนล่าสุด", selector: (row) => row },
      { name: "วันหมดอายุ", selector: (row) => row },
      { name: "Priority", selector: (row) => row },
      { name: "เหตุผลที่ข้ามขั้นตอน", selector: (row) => row },
      { name: "วันที่เปลี่ยน", selector: (row) => row },
      { name: "วันที่เปลี่ยนครั้งถัดไป", selector: (row) => row },
      { name: "ถึงวันที่", selector: (row) => row },
      { name: "สถานะชุดกรอง", selector: (row) => row }
    ],
    Record: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex, width: "82px" },
      { name: "ขั้นตอนการปฏิบัติงาน", selector: (row) => row },
      { name: "ค่า", selector: (row) => row },
      { name: "หน่วย", selector: (row) => row },
      { name: "Priority", selector: (row) => row },
      { name: "เหตุผลที่ข้ามขั้นตอน", selector: (row) => row },
      { name: "วันที่ปฏิบัติงาน", selector: (row) => row },
      { name: "ถ่ายรูป", selector: (row) => row },
      { name: "รูปภาพ", selector: (row) => row },
      { name: "หมายเหตุ", selector: (row) => row }
    ],
    Special: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex, width: "82px" },
      { name: "รายละเอียดข้อกำหนด", selector: (row) => row },
      { name: "ข้อกำหนดเพิ่มเติมอื่นๆ", selector: (row) => row },
      { name: "รอบ PM", selector: (row) => row },
      { name: "หมายเหตุ", selector: (row) => row }
    ]
  };

  return (
    <div className="position-relative">
      <PrintButton
        componentRef={canvasRef}
        button={{ style: { zIndex: 10, top: "25px", right: "25px" } }}
      />

      <Card.Body ref={canvasRef} className="mt-1">
        <CardDisplayComponent
          body={{
            as: Row,
            className: "mx-5",
            element: (
              <>
                <Col
                  sm={9}
                  className="ReportHead mb-3 d-flex align-items-center"
                >
                  <ReportHeadComponent formName="" />
                </Col>

                <Col as={Row} className="mb-3">
                  {showData(inputField.headerReport)}
                </Col>

                {showData(inputField.Inform)}
              </>
            )
          }}
        />

        <CardDisplayComponent
          header={{
            className: "mx-4 px-7",
            title: { text: "รายการสินค้า/อุปกรณ์/อะไหล่" }
          }}
          body={{
            className: "mx-4 px-7",
            element: <Table data={currentData?.BillOfReqDt || []} column={columns.Item} />
          }}
        />

        <CardDisplayComponent
          body={{
            as: Row,
            className: "justify-content-around ",
            element: inputField.Other.map(({ name, label }) => (
              <Col key={name} sm={3}>
                <FloatingControlComponent
                  readOnly
                  type="text"
                  name={name}
                  label={label}
                  value={formatSplitKey(name, ".", currentData)}
                />
              </Col>
            ))
          }}
        />
      </Card.Body>

      {/* <CardDisplayComponent
        body={{
          element: (
            <PaginationComponent
              data={state?.Work || []}
              currentPage={currentPage}
              itemsPerPage={1}
              onPageChange={(newPage) => setCurrentPage(newPage)}
            />
          )
        }}
      /> */}

      <CardDisplayComponent
        footer={{
          className: "text-center",
          element: (
            <Button
              variant="outline-secondary"
              className="px-4 py-2 text-dark rounded-pill"
              onClick={() =>
                navigate("/service_work/acceptance", {
                  state: { name: "CheckEquipment" }
                })
              }
            >
              ย้อนกลับ
            </Button>
          )
        }}
      />
    </div>
  );
};

PreviewEquipForm.propTypes = {
  Id: PropTypes.number.isRequired
};

export default PreviewEquipForm;
